var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDelivery = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 13.3337H3.33398V14.0003C3.33398 14.3685 3.0355 14.667 2.66732 14.667H2.00065C1.63246 14.667 1.33398 14.3685 1.33398 14.0003V7.33366L2.98765 3.4751C3.19776 2.98485 3.67981 2.66699 4.21318 2.66699H11.7881C12.3215 2.66699 12.8035 2.98485 13.0137 3.4751L14.6673 7.33366V14.0003C14.6673 14.3685 14.3689 14.667 14.0007 14.667H13.334C12.9658 14.667 12.6673 14.3685 12.6673 14.0003V13.3337ZM13.334 8.66699H2.66732V12.0003H13.334V8.66699ZM2.78461 7.33366H13.2167L11.7881 4.00033H4.21318L2.78461 7.33366ZM4.33398 11.3337C3.7817 11.3337 3.33398 10.8859 3.33398 10.3337C3.33398 9.78139 3.7817 9.33366 4.33398 9.33366C4.88627 9.33366 5.33398 9.78139 5.33398 10.3337C5.33398 10.8859 4.88627 11.3337 4.33398 11.3337ZM11.6673 11.3337C11.1151 11.3337 10.6673 10.8859 10.6673 10.3337C10.6673 9.78139 11.1151 9.33366 11.6673 9.33366C12.2196 9.33366 12.6673 9.78139 12.6673 10.3337C12.6673 10.8859 12.2196 11.3337 11.6673 11.3337Z",
    fill: "#1863DC"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelivery, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Delivery.6f4dc8e4.svg";
export { ForwardRef as ReactComponent };